<template>
  <div
    class="flex flex-row items-center w-full rounded-sm border bg-white border-gray-300 focus:border-gray-500 focus:ring-gray-500 sm:text-sm shadow-sm z-auto"
  >
    <input
      ref="inputRef"
      :value="modelValue"
      @input="emit('update:modelValue', $event)"
      :disabled="disabled"
      class="block w-full rounded-sm border-none focus:border-none focus:ring-0 sm:text-sm z-auto"
      :class="{
        'opacity-60 !cursor-not-allowed': disabled,
      }"
      :type="inputType"
      v-bind="$attrs"
      :autofocus="autofocus"
      autocomplete="off"
    />
    <div class="mx-2" v-if="compact && description">
      <Tooltip :content="description" origin="right">
        <HelpCircle class="w-4 h-4 text-gray-400" />
      </Tooltip>
    </div>
  </div>
</template>

<script setup>
import HelpCircle from "@/Tailwind/Icon/HelpCircle.vue";
import Tooltip from "@/Tailwind/Components/Tooltip.vue";
import { onMounted, ref } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inputType: {
    type: String,
    default: "text",
  },
  description: {
    type: String,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
});

const inputRef = ref();
onMounted(() => {
  if (!props.autofocus) {
    return;
  }

  inputRef.value.focus();
});

const emit = defineEmits(["update:modelValue"]);
</script>
